export const GET_ROLE = 'GET_ROLE';
export const GET_ROLES = 'GET_ROLES';
export const GET_MORE_ROLES = 'GET_MORE_ROLES';
export const GET_ROLES_MEMBER_COUNT = 'GET_ROLES_MEMBER_COUNT';
export const GET_MORE_ROLES_MEMBER_COUNT = 'GET_MORE_ROLES_MEMBER_COUNT';
export const ROLES_COUNT = 'ROLES_COUNT';
export const GET_PEOPLE_COUNT_IN_ROLE = 'GET_PEOPLE_COUNT_IN_ROLE';
export const GET_USERS_TO_ROLES = 'GET_USERS_TO_ROLES';
export const GET_GROUPS_COUNT_IN_ROLE = 'GET_GROUPS_COUNT_IN_ROLE';
export const GET_GROUPS_TO_ROLES = 'GET_GROUPS_TO_ROLES';
export const ROLES_FOR_SELECT = 'ROLES_FOR_SELECT';
